import About from "../components/About";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Tours from "../components/Tours";

const HomePage = () => {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Tours />
    </>
  );
};

export default HomePage;
